import React from 'react';

import { InfoMessage } from '@eika/attention-message';
import { IconTypes } from '@eika/icon';
import { Link, LinkType } from '@eika/link';

import { StringKeyValue } from '../../actions/types';
import ProductImage from '../../components/ProductImage/ProductImage';
import { CompletionReducer } from '../../reducers/completion';

interface Props {
    completion: CompletionReducer;
    creditFrozen: boolean;
    text: StringKeyValue;
}

const Rejected = ({ completion, creditFrozen, text }: Props): JSX.Element => {
    const { applicationId } = completion.ongoing;
    const {
        receiptRejectedTitle,
        receiptRejectedP1,
        receiptRejectedP2,
        receiptRejectedP3,
        receiptRejectedInfoBox,
        receiptRejectedButtonLink,
        receiptRejectedButtonText,
    } = text;

    return (
        <>
            {receiptRejectedTitle && (
                <ProductImage className="receipt__header" image="Stop" title={receiptRejectedTitle} />
            )}

            <div className="receipt__content">
                {receiptRejectedP1 && applicationId && (
                    <p>
                        <strong>{receiptRejectedP1}</strong> {applicationId}
                    </p>
                )}
                {creditFrozen && (
                    <InfoMessage
                        className="loan-info__info-message"
                        icon={IconTypes.LYSPAERE_24}
                        text={text.summaryInfoBoxDeclinedFrozen}
                    />
                )}
                {receiptRejectedP2 && <p>{receiptRejectedP2}</p>}
                {receiptRejectedP3 && <p>{receiptRejectedP3}</p>}
            </div>

            <div className="receipt__cta">
                <Link href={receiptRejectedButtonLink} linkType={LinkType.BUTTON_STANDARD_POSITIVE}>
                    {receiptRejectedButtonText}
                </Link>
            </div>

            {receiptRejectedInfoBox && (
                <InfoMessage className="receipt__info" text={receiptRejectedInfoBox} icon={IconTypes.LYSPAERE_24} />
            )}
        </>
    );
};
export default Rejected;
